import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketAdvertisement} from '../hooks/useGetBasketPageSection';
import {BasketBannerView} from './BasketBannerView';

export const BasketBanner = (props: {containBanner?: boolean}) => {
  return (
    <DataFetcher
      request={useBasketAdvertisement()}
      Error={() => null}
      View={BasketBannerView}
      viewProps={props}
    />
  );
};
